module.exports = __webpack_public_path__ + "static/media/logo.431d49de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.svg
// module id = 611
// module chunks = 0